module.exports = __webpack_public_path__ + "static/img/16.ff659574.png";